import { render, staticRenderFns } from "./OrderTip.vue?vue&type=template&id=44c05a4b&scoped=true&"
import script from "./OrderTip.vue?vue&type=script&lang=js&"
export * from "./OrderTip.vue?vue&type=script&lang=js&"
import style0 from "./OrderTip.vue?vue&type=style&index=0&id=44c05a4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c05a4b",
  null
  
)

export default component.exports